import React from 'react';
import { CardContainer } from '@lwt-helix/card';
import { SummaryCard } from './SummaryCard';

export const SummaryRow = ({ cardData }) => (
    <>
        <div className="mb-3">
            <CardContainer
                dataLwtId="summary-row-detail"
                className="summary-row-detail"
                type="group">
                {cardData?.map(({ id, value }, index) =>
                    <div key={index} className='summary-card-wrapper'>
                        <SummaryCard
                            id={id}
                            value={value}
                        />
                    </div>
                )}
            </CardContainer>
        </div>
    </>
);
